import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "upload-small",
  "use": "upload-small-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"upload-small\">\n  <path d=\"M4.007 4.828L4 4.818V3.635L8 1l4 2.635v1.183l-.007.01L8.5 2.527V11h-1V2.527L4.007 4.828zM11.5 7v1.036c.847.189 1.684.421 2.5.731L14.083 13H2V8.767c.816-.31 1.653-.542 2.5-.732V7c-1.212.256-2.384.62-3.5 1.091v5.66C3.153 14.555 5.518 15 8 15c2.483 0 4.848-.445 7-1.249v-5.66C13.884 7.62 12.712 7.256 11.5 7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol